import { render, staticRenderFns } from "./GuessList.vue?vue&type=template&id=4913a7e8&scoped=true&"
import script from "./GuessList.vue?vue&type=script&lang=js&"
export * from "./GuessList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4913a7e8",
  null
  
)

export default component.exports